export default function getActiveOptionValue() {
    return function (input) {
        for (var i = 0; i < input.length; i++) {
            if (input[i].active === true) {
                return input[i].value;
            }
        }
    }
};